export const SPECIALTIES = [
    "Orthopaedics - Foot and Ankle",
    "Orthopaedics - Shoulder and Elbow",
    "Orthopaedics - Knee",
    "Orthopaedics - Hip",
    "Orthopaedics - Wrist and Hand",
    "Orthopaedics - Spine",
    "Physiotherapy",
    "Rheumatology",
    "Sports Medicine",
    "General Practice",
    "Pain Doctor",
    "MSK Radiologist",
    "Prosthetist and Orthotist",
] as const;

export type Specialty = (typeof SPECIALTIES)[number];
